import {Component, inject} from '@angular/core';
import {ServiceCase} from '../../../../core/service-case/models/service-case';
import {ServiceCaseManager} from '../../../../core/service-case/models/service-case-manager';
import {
  DsBoxModule,
  DsButtonModule,
  DsFormFieldModule,
  DsHintModule,
  DsMessageModule,
  DsModalModule
} from '@bmw-ds/components';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-service-case-reload-overlay',
  templateUrl: './service-case-reload-overlay.component.html',
  styleUrls: ['./service-case-reload-overlay.component.scss'],
  imports: [DsModalModule, DsBoxModule, DsFormFieldModule, FormsModule, DsHintModule, DsButtonModule, DsMessageModule, TranslateModule]
})
export class ServiceCaseReloadOverlayComponent {
  private readonly serviceCaseManager: ServiceCaseManager = inject(ServiceCaseManager);

  visible: boolean = false;
  showVinMismatchError: boolean = false;

  vin17Input: string;

  serviceCase: ServiceCase;

  show(serviceCase: ServiceCase): void {
    this.visible = true;
    this.showVinMismatchError = false;
    this.serviceCase = serviceCase;
    this.vin17Input = serviceCase.getVinShort();
  }

  hide(): void {
    this.visible = false;
  }

  confirm(): void {
    if (!this.inputMatchesServiceCaseVin()) {
      this.showVinMismatchError = true;
    } else if (this.vin17Input?.length === 17) {
      this.showVinMismatchError = false;
      this.reloadCase();
    }
  }

  reloadCase(): void {
    if (this.vin17Input?.length === 17 && this.inputMatchesServiceCaseVin()) {
      this.setVin17InServiceCase(this.vin17Input);
    }

    // We do not need to save the service case here. We just reopen the service case, which will reload the vehicle
    // and save the service case afterward.
    this.serviceCaseManager.reloadServiceCaseById(this.serviceCase.getExternalId(), false)
      .finally(() => {
        // do nothing
      });

    this.hide();
  }

  private setVin17InServiceCase(vin17: string) {
    this.serviceCase.setVinLong(vin17);
    if (this.serviceCase.getVehicle()) {
      this.serviceCase.getVehicle()['vin'] = this.serviceCase.getVinLong();
    }
  }

  private inputMatchesServiceCaseVin(): boolean {
    return this.vin17Input.endsWith(this.serviceCase.getVinShort());
  }
}
